// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__1J52Q","login__logo":"login_login__logo__2l08U","login__captcha":"login_login__captcha__2ImFW","login__captcha__icon":"login_login__captcha__icon__2P3c2"};